const serviceUrlpattern = /:\/\/([^.]+)..+.knowledgehound.com:800\d(?:\/clients)?\/[^/]+(.+)$/

export default function translateServiceUrl(url) {
  const results = serviceUrlpattern.exec(url)
  return `/proxy/${results[1]}${results[2]}`
}
